/**
 * Community Post Edit Route
 */
import { createFileRoute } from '@tanstack/react-router';
import { authenticatedGetShared } from '@/lib/api/authenticated-shared';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';
import type { PostDetailV2 } from '@/lib/api/v2/community';

export const Route = createFileRoute('/_authenticated/community/posts/$postId_/edit')({
  // The edit route renders a form, not a post detail view — pending mirrors
  // the form shape. Title inlined from v2.createPostPage.editTitle (def files
  // stay eager and only import page-template-pending). The post form submits
  // from the sticky BottomAction bar.
  pendingComponent: () => <FormPageTemplatePending title="Edit your post" cta />,
  loader: ({ context, params }) => ({
    // Not awaited: the edit page owns its loading state, and its useQuery
    // consumes this same key, so priming (not blocking) is the loader's job.
    // Returning the promise keeps SSR cache-priming intact (the dehydrate
    // pipeline awaits it) while client navigations render immediately; the
    // catch keeps an unconsumed rejection from surfacing as unhandled — the
    // edit page's own query surfaces the failure state.
    postDetailPromise: context.queryClient
      .ensureQueryData({
        queryKey: ['community-post', params.postId],
        queryFn: () => authenticatedGetShared<PostDetailV2>(`/v2/community/posts/${params.postId}`),
      })
      .catch(() => undefined),
  }),
});
